<mat-card
  class="job-card m-10 p-0!"
  [ngClass]="{ 'unread-job bg-alice-blue': job()?.unread, 'active-job': job().jobId === activeJobId }"
  [routerLink]="!nextButtonPending() && !prevButtonPending() ? ['/jobViewer', job().jobId] : null"
  (click)="saveActiveJob(job().jobId)">
  <div class="mat-card-content flex flex-col justify-between h-fit">
    <section class="flex justify-between items-center gap-5 pl-10">
      <article
        class="body-2 display-ellipsis"
        matTooltip="{{
          (dateInBucket | daysSince: timezone) +
            ((dateInBucket | daysSince: timezone) === 1 ? ' day ' : ' days ') +
            'ago'
        }}"
        [matTooltipDisabled]="bucket() === 'REPAIR_BOOKED'">
        {{ relevantDate }}
      </article>

      <article class="flex">
        <div class="flex items-center gap-10">
          @if (job()?.unreadDiary) {
            <mat-icon class="size-14! text-14! text-red! -mt-[4px]" inline="true">comment_24px </mat-icon>
          }
          @if (job()?.unsubmittedDocument) {
            <mat-icon class="size-14! text-14! text-red! -mt-[4px]" inline="true">send </mat-icon>
          }
          @if (job().pendingSupplement) {
            <div matTooltip="This indicates that the job is pending a supplement assessment">
              <mat-icon class="size-18! text-18! text-red! mt-[4px]">running_with_errors</mat-icon>
            </div>
          }
        </div>
        <button
          matIconButton
          [matMenuTriggerFor]="optionsMenu"
          (click)="$event.stopPropagation()"
          class="p-0 mx-[-3px]">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #optionsMenu="matMenu" class="job-progress">
          <button class="p-0" (click)="archiveJob()" mat-menu-item>Archive job</button>
          <button class="p-0" (click)="toggleJobReadStatus(job()?.unread, job()?.jobId)" mat-menu-item>
            Mark as {{ job()?.unread ? 'read' : 'unread' }}
          </button>
        </mat-menu>
      </article>
    </section>

    <section class="min-[1367px]:grid min-[1366px]:grid-cols-4 mt-[-6px] px-10">
      <article class="flex flex-col gap-px min-[1366px]:col-span-3">
        <div
          #claim
          class="text-charcoal display-ellipsis subtitle-1"
          [class.scrolling-text]="setTextAnimation(claim, claimText)">
          <span #claimText [ngClass]="{ 'font-bold': job()?.unread }">
            @if (job()?.unread) {
              <mat-icon
                class="size-20! text-14! material-icons-outlined bg-dodger-blue text-white! rounded p-[3px]! mr-5">
                mark_email_unread_outline
              </mat-icon>
            }
            {{ job().claimNumber | uppercase }}
          </span>
        </div>

        <div
          #model
          class="body-2 display-ellipsis"
          [class.mt-5]="!job()?.claimNumber && !(job()?.ownerPersonName || job()?.ownerCompanyName)"
          [class.scrolling-text]="setTextAnimation(model, modelText)">
          <span #modelText>{{ job().insco | uppercase }}</span>
        </div>
        @if (job()?.ownerPersonName || job()?.ownerCompanyName) {
          <div
            #owner
            class="body-2 display-ellipsis flex items-center"
            matTooltip="{{
              setTextAnimation(owner, ownerText)
                ? job()?.ownerIsACompany
                  ? job()?.ownerCompanyName
                  : job()?.ownerPersonName
                : ''
            }}">
            <mat-icon class="size-14! text-14!">account_circle</mat-icon>
            <span #ownerText class="leading-snug ml-[2px]">
              {{ (job()?.ownerIsACompany ? job()?.ownerCompanyName : job()?.ownerPersonName) | uppercase }}</span
            >
          </div>
        }
        <div
          #vehicleDescription
          class="body-2 display-ellipsis"
          [class.scrolling-text]="setTextAnimation(vehicleDescription, vehicleDescriptionSpan)">
          <span #vehicleDescriptionSpan class="text-charcoal-50">{{ job().vehicleDescription }}</span>
        </div>
        <div class="flex mt-10" [ngClass]="job().totalLoss ? 'justify-between' : 'justify-end'">
          @if (job().totalLoss) {
            <div class="w-fit body-3 flex items-center gap-[4px] rounded bg-orange py-[4px] px-5">
              <mat-icon svgIcon="total_loss_icon" class="size-14! text-14!"></mat-icon>
              <span class="mt-[1px] body-3 font-black">TOTAL LOSS</span>
            </div>
          }
          <div class="min-[1367px]:hidden">
            <ng-container *ngTemplateOutlet="rego"></ng-container>
          </div>
        </div>
      </article>

      <article class="max-[1366px]:hidden flex flex-col justify-center items-center">
        @if (job().photoIdentityUI?.preSignedUrl) {
          <img
            [hidden]="!photoLoaded[job().jobId]"
            class="h-[54px] w-[54px] mb-5 rounded object-cover"
            [src]="job().photoIdentityUI.preSignedUrl"
            (error)="photoLoaded[job().jobId] = false"
            (load)="photoLoaded[job().jobId] = true" />
        }
        @if (!job().photoIdentityUI?.preSignedUrl || !photoLoaded[job().jobId]) {
          <img class="h-auto w-[54px] mb-5 rounded placeholder" src="../../../assets/images/car-placeholder.svg" />
        }
        <ng-container *ngTemplateOutlet="rego"></ng-container>
      </article>
    </section>

    <section
      class="bottom-icon flex items-center p-10"
      [ngClass]="{
        'justify-between': !['VEHICLE_IN', 'REPAIR_BOOKED'].includes(bucket()),
        'justify-end': ['VEHICLE_IN', 'REPAIR_BOOKED'].includes(bucket())
      }">
      @if (['REPAIR_STARTED', 'REPAIR_COMPLETED', 'VEHICLE_OUT'].includes(bucket())) {
        <button
          matButton="elevated"
          class="neutral-button h-25! left-button p-0"
          matTooltip="Use this function to regress the vehicle one step back in the repair progress"
          [disabled]="prevButtonPending() || nextButtonPending() || userService.isRepairerSiteSuspended()"
          (click)="$event.stopPropagation(); !prevButtonPending() && moveToPreviousBucket()">
          @if (!prevButtonPending()) {
            <mat-icon class="next-icon w-21! h-12! m-0!" svgIcon="back_icon"></mat-icon>
          }
          @if (prevButtonPending()) {
            <mat-spinner class="my-0 mx-auto" mode="indeterminate" [diameter]="20" />
          }
        </button>
      }
      @if (bucket() !== 'VEHICLE_OUT') {
        <button
          matButton="elevated"
          class="neutral-button h-25! right-button p-0"
          matTooltip="Use this function to progress the vehicle through the 4 phases of the repair progress"
          [disabled]="prevButtonPending() || nextButtonPending() || userService.isRepairerSiteSuspended()"
          (click)="$event.stopPropagation(); !nextButtonPending() && moveToNextBucket()">
          @if (!nextButtonPending()) {
            <mat-icon class="next-icon w-21! h-12! m-0!" svgIcon="next_icon"></mat-icon>
          }
          @if (nextButtonPending()) {
            <mat-spinner class="my-0 mx-auto" mode="indeterminate" [diameter]="20" />
          }
        </button>
      }
    </section>
  </div>
</mat-card>

<ng-template #rego>
  @if (job()?.rego) {
    <div class="rego-span body-2 text-charcoal max-w-[80px] min-w-fit display-ellipsis">{{ job().rego }}</div>
  }
</ng-template>
